import {deleteServiceAuthorized, getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized, putServiceAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';
const RefreshTokenService = {};
RefreshTokenService.getRenualAccessToken = (payload) => AxiosRequest.post(
  `/${route.auth}/api/v1/authNode/refresh`,
  payload
)
RefreshTokenService.tokenStatus = (payload) => AxiosRequest.post(
    `/${route.auth}/api/v1/authNode/check/loginStatus`,
    payload
  )

export default RefreshTokenService;